module.exports = __webpack_public_path__ + "assets/img/cases-1.6a803726.png";